import { httpToken } from "@/utils/http";
// import qs from "qs";
// 可以使用的内部车牌号
export function getinCarNum() {
  return httpToken({
    url: '/granary-dumped/save/inCarNum',
    method: 'post',
  }).then(res => {
    console.log('可以使用的内部车牌号', res)
    return res.data.data.map(item => {
      return {
        'label': item,
        'value': item
      }
    })
  })
}
// 获取检验结果下拉数据
export function getcheckResultData() {
  return [
    {
      value: "1",
      label: "合格",
    },
    {
      value: "0",
      label: "不合格",
    },
  ]
}

// 获取包装方式下拉数据
export function getpackingWayData() {
  return [
    {
      value: "1",
      label: "麻袋",
    },
    {
      value: "2",
      label: "编织方式",
    },
    {
      value: "3",
      label: "散装",
    },
    {
      value: "9",
      label: "其他",
    },
  ]
}
// 获取运输工具下拉数据
export function gettransportData() {
  return [
    {
      value: "1",
      label: "汽车",
    },
    {
      value: "2",
      label: "火车",
    },
    {
      value: "3",
      label: "轮船",
    },
    {
      value: "9",
      label: "其他",
    },
  ]
}
// 获取检斤类型下拉数据
export function getjjlxData() {
  return [
    {
      value: "0",
      label: "称重入库",
    },
    {
      value: "1",
      label: "标准包入库",
    },
  ]
}
// 获取客户类型下拉数据
export function getcustomerTypeData() {
  return [
    {
      value: "1",
      label: "企业",
    },
    {
      value: "2",
      label: "个人",
    },
  ]
}
// 获取性别下拉数据
export function getSexData() {
  return [
    {
      value: 1,
      label: "男",
    },
    {
      value: 2,
      label: "女",
    },
  ]
}
// 获取岗位下拉数据
export function getjobNatureData() {
  return [
    {
      value: '11',
      label: "在岗职工(长期)",
    },
    {
      value: '12',
      label: "在岗职工(临时)",
    },
    {
      value: '20',
      label: "其他从业人员",
    },
  ]
}
// 获取在岗状态下拉数据
export function getonDutyStatusData() {
  return [
    {
      value: '01',
      label: "在岗",
    },
    {
      value: '02',
      label: "已离职",
    },
  ]
}
// 获取学历下拉数据
export function getDegreeData() {
  return [
    {
      value: "0",
      label: "研究生",
    },
    {
      value: "1",
      label: "大学本科",
    },
    {
      value: "2",
      label: "大学专科",
    },
    {
      value: "3",
      label: "中专",
    },
    {
      value: "4",
      label: "高中及以下",
    },
  ]
}
// 获取政治面貌信息下拉方式
export function getPartyData() {
  return [
    {
      value: "01",
      label: "中国共产党党员",
    },
    {
      value: "02",
      label: "中国共产党预备党员",
    },
    {
      value: "03",
      label: "中国共产主义青年团团员",
    },
    {
      value: "04",
      label: "中国国民党革命委员会会员",
    },
    {
      value: "05",
      label: "中国主同盟盟员",
    },
    {
      value: "06",
      label: "中国民主建国会会员",
    },
    {
      value: "07",
      label: "中国民主促进会会员",
    },
    {
      value: "08",
      label: "中国农工民主党党员",
    },
    {
      value: "09",
      label: "中国致公党党员",
    },
    {
      value: "10",
      label: "九三学社社员",
    },
    {
      value: "11",
      label: "台湾民主自治同盟盟员",
    },
    {
      value: "12",
      label: "无党派民主人士",
    },
    {
      value: "13",
      label: "群众",
    },
  ]
}
// 获取民族下拉数据
export function getgroupData() {
  return [
    {
      value: "01",
      label: "汉族",
    },
    {
      value: "02",
      label: "蒙古族",
    },
    {
      value: "03",
      label: "回族",
    },
    {
      value: "04",
      label: "藏族",
    },
    {
      value: "05",
      label: "维吾尔族",
    },
    {
      value: "06",
      label: "苗族",
    },
    {
      value: "07",
      label: "彝族",
    },
    {
      value: "08",
      label: "壮族",
    },
    {
      value: "09",
      label: "布依族",
    },
    {
      value: "10",
      label: "朝鲜族",
    },
    {
      value: "11",
      label: "满族",
    },
    {
      value: "12",
      label: "侗族",
    },
    {
      value: "13",
      label: "瑶族",
    },
    {
      value: "14",
      label: "白族",
    },
    {
      value: "15",
      label: "土家族",
    },
    {
      value: "16",
      label: "哈尼族",
    },
    {
      value: "17",
      label: "哈萨克族",
    },
    {
      value: "18",
      label: "傣族",
    },
    {
      value: "19",
      label: "黎族",
    },
    {
      value: "20",
      label: "傈僳族",
    },
    {
      value: "21",
      label: "佤族",
    },
    {
      value: "22",
      label: "畲族",
    },
    {
      value: "23",
      label: "高山族",
    },
    {
      value: "24",
      label: "拉祜族",
    },
    {
      value: "25",
      label: "水族",
    },
    {
      value: "26",
      label: "东乡族",
    },
    {
      value: "27",
      label: "纳西族",
    },
    {
      value: "28",
      label: "景颇族 ",
    },
    {
      value: "29",
      label: "柯尔克孜族",
    },
    {
      value: "30",
      label: "土族",
    },
    {
      value: "31",
      label: "达斡尔族",
    },
    {
      value: "32",
      label: "仫佬族",
    },
    {
      value: "33",
      label: "羌族",
    },
    {
      value: "34",
      label: "布朗族",
    },
    {
      value: "35",
      label: "撒拉族",
    },
    {
      value: "36",
      label: "毛难族",
    },
    {
      value: "37",
      label: "仡佬",
    },
    {
      value: "38",
      label: "锡伯族",
    },
    {
      value: "39",
      label: "阿昌族",
    },
    {
      value: "40",
      label: "普米族",
    },
    {
      value: "41",
      label: "塔吉克族",
    },
    {
      value: "42",
      label: "怒族",
    },
    {
      value: "43",
      label: "乌孜别克族",
    },
    {
      value: "44",
      label: "俄罗斯族",
    },
    {
      value: "45",
      label: "鄂温克族",
    },
    {
      value: "46",
      label: "崩龙族",
    },
    {
      value: "47",
      label: "保安族",
    },
    {
      value: "48",
      label: "裕固族",
    },
    {
      value: "49",
      label: "京族",
    },
    {
      value: "50",
      label: "塔塔尔族",
    },
    {
      value: "51",
      label: "独龙族",
    },
    {
      value: "52",
      label: "鄂伦春族",
    },
    {
      value: "53",
      label: "赫哲族",
    },
    {
      value: "54",
      label: "门巴族",
    },
    {
      value: "55",
      label: "珞巴族",
    },
    {
      value: "56",
      label: "基诺族",
    },

  ]
}
// 获取波特率下拉
export function getBaudRate() {
  return [
    {
      value: "300",
      label: "300",
    },
    {
      value: "600",
      label: "600",
    },
    {
      value: "1200",
      label: "1200",
    },
    {
      value: "2400",
      label: "2400",
    },
    {
      value: "4800",
      label: "4800",
    },
    {
      value: "9600",
      label: "9600",
    },
    {
      value: "14400",
      label: "14400",
    },
    {
      value: "19200",
      label: "19200",
    },
    {
      value: "38400",
      label: "38400",
    },
    {
      value: "43000",
      label: "43000",
    },
    {
      value: "56000",
      label: "56000",
    },
    {
      value: "57600",
      label: "57600",
    },
    {
      value: "115200",
      label: "115200",
    },
    {
      value: "128000",
      label: "128000",
    },
    {
      value: "256000",
      label: "256000",
    },
  ]
}